// Package imports:
import React, { useEffect } from "react";
import Bugsnag from "@bugsnag/js";
// Component imports:
import Modal from "../../../ui-elements/Modal/Modal";
import Alert from "../../../ui-elements/Alert/Alert";
import Loading from "../../../ui-elements/Loading/Loading";
import ForeignPepModal from "../ForeignPepModal";
// Type imports:
import { PepResult, PepWatchListData, PepWatchResponse } from "../../../types/PepTypes";
import { IKeldanApiResponse } from "../../../types/KeldanTypes";

interface IProps {
  show: boolean;
  close(): void;
  id?: string;
}

const PepWatchSanctionsConnectionModal: React.FC<IProps> = ({ show, close, id }) => {
  const [data, setData] = React.useState<PepResult[] | undefined | Error>(undefined);
  const [loading, setLoading] = React.useState<boolean>(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await fetch(`/pep/GetPersonDataWatchList?id=${id}`);

        if (!response.ok) {
          throw new Error(`Error: ${response.status}`);
        }

        const responseBody: IKeldanApiResponse<PepWatchResponse<PepWatchListData>> = await response.json();
        if (responseBody.success) {
          if (responseBody.result?.data) {
            setData(
              parseSanctionsResponse(
                responseBody.result.data.lastSanctionsResponse
              )
            );
          }
        }
      } catch (err) {
        if(err instanceof Error) {
          Bugsnag.notify(err);
          setData(new Error("Ekki tókst að sækja gögn um alþjóðlega válista. Vinsamlegast reyndu aftur síðar."));
        }
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchData();
    }
  }, [id]); // Re-fetch when id changes

  const parseSanctionsResponse = (responseString: string): PepResult[] => {
    try {
      if (!responseString || responseString.trim() === "") {
        return [];
      }

      const parsed = JSON.parse(responseString);
      return parsed.match || [];
    } catch (error) {
      console.error("Error parsing sanctions response:", error);
      return [];
    }
  };

  if (loading) {
    return <Modal show={show} onHide={close}>
      <Loading />
    </Modal>;
  }
  if (data instanceof Error) {
    return <Modal show={show} onHide={close}>
      <Alert type="error" headText={data.message} />
    </Modal>;
  }
  if (data === undefined || loading) { return null; }
  return <ForeignPepModal show={show} close={close} data={data} />
};

export default PepWatchSanctionsConnectionModal;
